'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addStringifier = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.setOptions = setOptions;
exports.setContextRetriever = setContextRetriever;
exports.setStateGetter = setStateGetter;
exports.addRemote = addRemote;

var _getConsoleFunction = require('./util/getConsoleFunction');

var _getConsoleFunction2 = _interopRequireDefault(_getConsoleFunction);

var _stringifyArgs = require('./util/stringifyArgs');

var _stringifyArgs2 = _interopRequireDefault(_stringifyArgs);

var _getCallerLocation = require('./util/getCallerLocation');

var _getCallerLocation2 = _interopRequireDefault(_getCallerLocation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.addStringifier = _stringifyArgs.addStringifier;


var dataStore = {
  contextRetriever: function contextRetriever() {
    return {};
  },
  dev: false,
  getState: function getState() {
    return {};
  },
  remotes: [],
  force: false,
  production: process.env.NODE_ENV === 'production',
  test: process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'testing',
  logCallLocation: false
};
dataStore.development = process.env.NODE_ENV === 'development' || !dataStore.production && !dataStore.test;

function setOptions() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dataStore,
      contextRetriever = _ref.contextRetriever,
      getState = _ref.getState,
      force = _ref.force,
      production = _ref.production,
      test = _ref.test,
      logCallLocation = _ref.logCallLocation;

  dataStore.contextRetriever = contextRetriever;
  dataStore.force = force;
  dataStore.getState = getState;
  dataStore.production = production;
  dataStore.test = test;
  dataStore.logCallLocation = logCallLocation;
}

function setContextRetriever(fn) {
  dataStore.contextRetriever = fn;
}

function setStateGetter(getState) {
  dataStore.getState = getState;
}

function addRemote(fn) {
  dataStore.remotes.push(fn);
}

function getContext() {
  return dataStore.contextRetriever(dataStore.getState(), function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _stringifyArgs2.default.apply(undefined, [0].concat(args));
  });
}

function sendToRemotes(prop, data, context) {
  dataStore.remotes.forEach(function (remote) {
    return remote(prop, data, context);
  });
}

function getLogString(data, location, context) {
  var s = data.concat('\n  context: ', (0, _stringifyArgs2.default)(0, context));
  if (location != null) {
    return s.concat('\n  ', 'at ' + location.file + ':' + location.line + ':' + location.column);
  }
  return s;
}

function logToConsole(fn, data) {
  return fn.call(console, data);
}

function print(prop) {
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (dataStore.test && !dataStore.force) {
      return null;
    }
    var data = _stringifyArgs2.default.apply(undefined, [0].concat(args));
    var context = getContext();
    var p = prop.toUpperCase();
    var consoleFunction = (0, _getConsoleFunction2.default)(p);
    var callerLocation = dataStore.logCallLocation ? (0, _getCallerLocation2.default)() : null;
    if (dataStore.dev) {
      dataStore.dev = false;
      if (dataStore.development) {
        return logToConsole(consoleFunction, getLogString(data, callerLocation, context));
      }
      return null;
    }
    if (dataStore.production) {
      return sendToRemotes(p, data, context);
    }
    if (dataStore.development) {
      return logToConsole(consoleFunction, getLogString(data, callerLocation, context));
    }
    return null;
  };
}

var jack = function jack() {
  if (typeof Proxy !== 'function') {
    var _ret = function () {
      var oldjack = {
        log: print('log'),
        info: print('info'),
        error: print('error'),
        debug: print('debug'),
        warn: print('warn')
      };
      Object.defineProperties(oldjack, {
        dev: {
          get: function get() {
            dataStore.dev = true;
            return oldjack;
          }
        }
      });
      return {
        v: oldjack
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
  return new Proxy({}, {
    get: function get(target, prop) {
      if (prop === 'dev') {
        dataStore.dev = true;
        return jack();
      }
      return print(prop);
    }
  });
};

exports.default = jack();


//////////////////
// WEBPACK FOOTER
// ./~/jack-logs/index.js
// module id = 32
// module chunks = 0